import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '../Shared/shared-service.service';
import { RestApiService } from '../API/restapi';
import { ALERT_TYPE } from '../constants';

interface FileAction {
  type: string;
  url: string;
  callback?: () => void;
}

@Component({
  selector: 'app-file-uploader',
  standalone: false,
  templateUrl: './file-uploader.component.html',
  styleUrl: './file-uploader.component.scss',
})
export class FileUploaderComponent {
  private activeModal = inject(NgbActiveModal);
  private restApi = inject(RestApiService);
  private sharedService = inject(SharedService);

  @Input() fileAction: FileAction;
  @Input() title: string = 'Upload File / Image';
  file: File;
  disableSubmit = true;

  handleFileInput(files: FileList) {
    this.disableSubmit = false;
    this.file = files.item(0);
  }

  addFile() {
    if (this.file == undefined) {
      this.sharedService.openAlert("Please select 1 file before proceed!", ALERT_TYPE.DANGER);
    } else {
      this.disableSubmit = true;
      try {
        this.restApi.postFile(this.fileAction.url, this.file).subscribe({
          next: async (res) => {
            this.sharedService.openAlert("Done Upload", ALERT_TYPE.SUCCESS);
            this.file = undefined;
          },
          error: (err) => {
            this.restApi.handleError(err)
          }
        })
      } finally {
        this.disableSubmit = false;
      }
    }
  }

  reset() {
    this.activeModal.close();
  }
}
